import api from '@/api';

// head 태그를 "한 군데"에서만 관리하기 위한 data 속성
const SEO_ATTR = 'data-lecos-seo';

function upsertMetaByName(name, content) {
    if (!content && content !== '') return;

    let el = document.head.querySelector(`meta[name="${name}"][${SEO_ATTR}]`);
    if (!el) {
        // 혹시 기존(서버/다른 플러그인) meta가 있으면 재사용
        el = document.head.querySelector(`meta[name="${name}"]`) || document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
    el.setAttribute(SEO_ATTR, '1');
}

function upsertMetaByProperty(prop, content) {
    if (!content && content !== '') return;

    let el = document.head.querySelector(`meta[property="${prop}"][${SEO_ATTR}]`);
    if (!el) {
        el = document.head.querySelector(`meta[property="${prop}"]`) || document.createElement('meta');
        el.setAttribute('property', prop);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
    el.setAttribute(SEO_ATTR, '1');
}

function upsertCanonical(href) {
    if (!href) return;

    let el = document.head.querySelector(`link[rel="canonical"][${SEO_ATTR}]`);
    if (!el) {
        el = document.head.querySelector('link[rel="canonical"]') || document.createElement('link');
        el.setAttribute('rel', 'canonical');
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
    el.setAttribute(SEO_ATTR, '1');
}

/**
 * 백엔드에서 받은 SeoMeta를 head에 반영
 */
export function applySeoMeta(meta) {
    if (!meta) return;

    // ✅ title (여기서만 관리)
    if (meta.title) document.title = meta.title;

    // ✅ 기본 meta
    upsertMetaByName('description', meta.description || '');
    if (meta.keywords) upsertMetaByName('keywords', meta.keywords);

    // ✅ og
    upsertMetaByProperty('og:type', meta.ogType || 'website');
    upsertMetaByProperty('og:title', meta.ogTitle || meta.title || '');
    upsertMetaByProperty('og:description', meta.ogDescription || meta.description || '');
    if (meta.ogImage) upsertMetaByProperty('og:image', meta.ogImage);

    // ✅ canonical
    if (meta.canonical) upsertCanonical(meta.canonical);
}

/**
 * 현재 SPA 경로에 맞는 SeoMeta를 백엔드에서 가져와 적용
 */
export async function syncSeoByRoute(to) {
    try {
        const path = to.fullPath || to.path || '/';
        const res = await api.get('/Seo/meta', { params: { path } });
        applySeoMeta(res.data);
    } catch (e) {
        // 실패해도 SPA는 동작해야 하므로 조용히 무시
        // console.warn('SEO sync failed', e);
    }
}
